var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUiLabelWideOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "none",
    style: {
      width: "100%",
      height: "100%"
    },
    viewBox: "0 0 346.652 60.362",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "UI_Label_wide_orange",
    d: "M30,4.76l7.338,15L30,54.859l344.486-7.648L366.4,26.176,375.751.524Z",
    transform: "matrix(1, 0.017, -0.017, 1, -29.033, -1.047)",
    fill: "#c78b43"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUiLabelWideOrange);
export default __webpack_public_path__ + "static/media/UI_Label_wide_orange.88e572d033aca7649f92480d0bcb2210.svg";
export { ForwardRef as ReactComponent };